<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">Config ONT {{ ontIndex }}</div>
      </div>
    </div>
    <!--页面提示
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the ont info." }}
      </p>
    </div>-->
    <div>
      <span style="margin: 1px"></span>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--gemport-->
        <pane label="Gemport">
          <unique-gemport :uniqueOnt="ontIndex"></unique-gemport>
        </pane>
        <!--tcont-->
        <pane label="Tcont">
          <unique-tcont :uniqueOnt="ontIndex"></unique-tcont>
        </pane>
        <!--ip config
        <pane label="IP Config">
          <unique-ip :uniqueOnt="ontIndex"></unique-ip>
        </pane>-->
        <!--sip-->
        <pane label="Sip">
          <unique-sip :uniqueOnt="ontIndex"></unique-sip>
        </pane>
        <!--poe
        <pane label="Poe">
          <unique-poe :uniqueOnt="ontIndex"></unique-poe>
        </pane>-->
        <!--Local
        <pane label="Local">
          <unique-local :uniqueOnt="ontIndex"></unique-local>
        </pane>-->
      </tabs>
    </div>
  </div>
</template>

<script>

import BlockCntr from "@/components/BlockCntr.vue"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import UniqueGemport from "@/views/ProfileUniqueGemport.vue"
import UniqueTcont from "@/views/ProfileUniqueTcont.vue"
//import UniqueIp from "@/views/ProfileUniqueIp.vue"
//import UniquePoe from "@/views/ProfileUniquePoe.vue"
import UniqueSip from "@/views/ProfileUniqueSip.vue"
//import UniqueLocal from "@/views/ProfileUniqueLocal.vue"

export default {
  data() {
    return {
      ontIndex: this.$route.query.uniqueOntIndex,
      activeIndex: 0,
    }
  },
  components: {
    BlockCntr,
    tabs,
    pane,
    UniqueGemport,
    UniqueTcont,
    //UniqueIp,
    //UniquePoe,
    UniqueSip,
    //UniqueLocal
  },
  created() {},
  methods: {},
}
</script>